<template>
  <div class="btnContent" v-if="hasAuth">
    <el-button
      :disabled="disabled"
      :type="type"
      :plain="plain"
      :icon="icon"
      v-if="authType === 'btn'"
      :loading="loading"
      :size="size"
      :download="download">{{ label }}</el-button>
    <span v-else>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'AuthButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    authType: {
      type: String,
      default: 'btn' // button标签或span标签
    },
    // el-button的按钮的属性，authType为button才有效
    type: {
      type: String,
      default: 'primary'
    },
    // authType为button才有效
    icon: {
      type: String,
      default: ''
    },
    // 用来判断是否有权限
    opt: {
      type: String,
      default: 'add' // 页面需唯一
    },
    // 按钮文本
    label: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    download: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'middle'
    }
  },
  data () {
    return {
      hasAuth: false
    }
  },
  mounted () {
    // 如果是列表中的按钮，不需每个都判断，因此定义一个父级变量，存储已有权限
    if (this.$parent.buttonOpt && this.$parent.buttonOpt.includes(this.opt)) {
      this.hasAuth = true
    }
    if (this.$route.meta.handler && this.$route.meta.handler.length > 0) {
      const that = this
      this.hasAuth = this.$route.meta.handler.some(item => {
        if (!that.$parent.buttonOpt) {
          that.$parent.buttonOpt = []
        }
        that.$parent.buttonOpt.push(this.opt)
        return item.opt === this.opt
      })
    }

    // 后续删除
    this.hasAuth = true
  }
}
</script>
<style scoped>
.btnContent{
  display: inline-block;
}
.btnContent + .btnContent{
  margin-left: 10px;
}
</style>
